import { Waypoint } from 'react-waypoint';
import React, { useState } from 'react';
import './Services.scss';

import { motion } from 'framer-motion';

import websiteDesignLottie from '../../../assets/lotties/website-design.json';
import ECommerceLottie from '../../../assets/lotties/e-commerce.json';
import SEOLottie from '../../../assets/lotties/seo.json';
import HostingLottie from '../../../assets/lotties/hosting.json';
import GraphicDesignLottie from '../../../assets/lotties/graphic-design.json';

import { homePage } from '../../../editable-stuff/config';
import { ReactComponent as WebsiteIcon } from '../../../assets/img/website.svg';
import { ReactComponent as ECommerceIcon } from '../../../assets/img/ecommerce.svg';
import { ReactComponent as SeoIcon } from '../../../assets/img/seo.svg';
import { ReactComponent as HostingIcon } from '../../../assets/img/hosting.svg';
import { ReactComponent as GraphicDesignIcon } from '../../../assets/img/graphic-design.svg';

import GradientButton from '../../../Library/GradientButton/GradientButton';
import LottieAnimator from '../../../Library/LottieAnimator/LottieAnimator';

export default function Services() {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: 'Website Design',
      svg: 'website',
      id: '#website-design-panel',
    },
    {
      title: 'E-Commerce',
      svg: 'ecommerce',
      id: '#e-commerce-panel',
    },
    {
      title: 'SEO',
      svg: 'seo',
      id: '#seo-panel',
    },
    {
      title: 'Hosting',
      svg: 'hosting',
      id: '#hosting-panel',
    },
    {
      title: 'Graphic Design',
      svg: 'graphic-design',
      id: '#graphic-design-panel',
    },
  ];

  const tabsContent = [
    {
      title: 'Bespoke Solution',
      gradientTitle: 'Website Design',
      description: (
        <>
          As an <strong>award-winning London web design agency</strong>, we have
          a phased approach to our web design projects which ensures all aspects
          of creating a high-performance website are effectively considered. We
          have a highly skilled in-house team with a diverse skill set ensuring
          we’re able to provide a specialist for each stage of your web project.
          <br />
          Our web design USP’s include:
        </>
      ),
      descriptionPoints: [
        <>
          Bespoke design and development – Our industry leading websites are
          designed and developed from scratch in house by our{' '}
          <strong>London based web design team</strong> - we do not use themes
          or site builders.
        </>,
        <>
          Without compromise – by custom building all our websites we are able
          to fulfil all design and functionality requirements without having to
          comprise on quality.
        </>,
        <>
          Interactive websites – we create websites that animate, respond, and
          interact producing an engaging user experience through site animation
          techniques including Canvas elements, Lottie.js and WebGL
          technologies.
        </>,
        <>
          SEO - We plan, design and develop our websites with careful SEO
          consideration ensuring they are ready to competitively rank and
          perform once launched.
        </>,
        <>
          Optimized user experience – During our discovery and wireframing
          phases we consider your websites user journey, demographics and UI in
          order to create a website with a well-thought-out user flow -
          delivering an overall better site engagement and conversion rate.
        </>,
      ],
      button: {
        text: 'Website Design',
        link: '#',
        svg: 'website',
      },
    },
    {
      title: 'Scalable Solutions',
      gradientTitle: 'E-Commerce',
      description: (
        <>
          We offer industry-leading, enterprise standard e-commerce systems as
          part of our website services. Our e-commerce websites are fully
          bespoke, adapted to work seamlessly with your business model – whether
          it be drop shipping, virtual products, or international sales: our
          expert London based web design team have you covered. We specialise in
          scalable e-commerce sites that are easy for our clients to update,
          with user-friendly product management, integration with a range of
          payment systems, and a fully secure customer shopping experience.
        </>
      ),
      descriptionPoints: [
        <>
          Industry leading, scalable e-commerce systems including Woocommerce
          &amp; Magento.
        </>,
        <>
          Integrated, SSL Secure payment – accept a range of payments online,
          including subscriptions, credit/debit cards, and Apple/Android pay.
        </>,
        <>
          Complete control over your site, with easy in-house management of your
          online store.
        </>,
        <>
          Integration of advanced reporting tools such as Google Analytics to
          track user behaviour and optimise for revenue/conversions.
        </>,
      ],
      button: {
        text: 'E-Commerce Solutions',
        link: '#',
        svg: 'ecommerce',
      },
    },
    {
      title: 'Result Driven',
      gradientTitle: 'SEO',
      description: (
        <>
          Unlike many specialist marketing &amp; SEO companies, as a
          full-service London agency we have the advantage of being able to
          carry out a successful digital marketing campaign, completely
          in-house. This allows us to make both small &amp; complex changes to a
          website as part of an SEO strategy, avoiding any unnecessary to-ing
          &amp; fro-ing &amp; ensuring that work is carried out as efficiently
          as possible.
        </>
      ),
      descriptionPoints: [
        <>
          Certified Google Partners, passionate about achieving real results for
          your business.
        </>,
        <>Tailored digital marketing solutions, unique to your requirements.</>,
        <>Full onsite optimisation for search engine indexing &amp; ranking.</>,
        <>
          Appear in Google page results for the searches that are important to
          you.
        </>,
        <>
          Transparent monthly reporting on progress, rankings, conversions &amp;
          tangible ROI.
        </>,
      ],
      button: {
        text: 'SEO Solutions',
        link: '#',
        svg: 'seo',
      },
    },
    {
      title: 'Managed Solutions',
      gradientTitle: 'Hosting Solutions',
      description: (
        <>
          Our servers load websites up to 5x faster (TTFB) than shared hosting
          services and make use of cloud flare DNS which ensures that your site
          doesn’t go down, is kept secure, and consistently runs quickly via
          caching.
        </>
      ),
      descriptionPoints: [
        <>Amazon S3 Backups.</>,
        <>
          Free Setup – We move your site over and perform all technical set up.
        </>,
        <>Daily Antivirus Scans of the server</>,
        <>Managed Firewall to prevent hackers and spam</>,
        <>24×7 External Monitoring</>,
        <>24×7 UK support</>,
        <>SLA – Service Level Agreement for your peace of mind.</>,
      ],
      button: {
        text: 'Hosting Solutions',
        link: '#',
        svg: 'hosting',
      },
    },
    {
      title: 'Bespoke & Unique',
      gradientTitle: 'Graphic Design',
      description: `We have a dedicated London based design team who are experts
      in creating impactful UI/UX optimised design, stunning logos
      and considered branding. As a full service London agency
      we’re able to provide a complete design, online and digital
      marketing solution.`,
      descriptionPoints: [
        'Brand Design',
        'Graphic Design',
        'Logo Design',
        'Print Design work',
        'Business Stationery',
        'Brand Guidelines.',
        <>
          Internal &amp; External communications (emails, brochures,
          presentations (PowerPoint), infographics, advertising creative,
          related marketing collateral)
        </>,
      ],
      button: {
        text: 'Graphic Design',
        link: '#',
        svg: 'graphic-design',
      },
    },
  ];

  return (
    <section id='content-tabs' className='p-100 bg-light'>
      <div className='wave-top'>
        <svg
          fill='#f6f6f6'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 1000 300'
          preserveAspectRatio='none'
        >
          <path d='M 1000 299 l 2 -279 c -155 -36 -310 135 -415 164 c -102.64 28.35 -149 -32 -232 -31 c -80 1 -142 53 -229 80 c -65.54 20.34 -101 15 -126 11.61 v 54.39 z'></path>
          <path d='M 1000 286 l 2 -252 c -157 -43 -302 144 -405 178 c -101.11 33.38 -159 -47 -242 -46 c -80 1 -145.09 54.07 -229 87 c -65.21 25.59 -104.07 16.72 -126 10.61 v 22.39 z'></path>
          <path d='M 1000 300 l 1 -230.29 c -217 -12.71 -300.47 129.15 -404 156.29 c -103 27 -174 -30 -257 -29 c -80 1 -130.09 37.07 -214 70 c -61.23 24 -108 15.61 -126 10.61 v 22.39 z'></path>
        </svg>
      </div>
      <div className='container'>
        <div className='headers text-center mb-8'>
          <motion.h4
            initial={{ y: '100px', opacity: 0 }}
            whileInView={{ y: '0', opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            {homePage.services.title}
          </motion.h4>
          <motion.h2
            className='gradient'
            initial={{ y: '100px', opacity: 0 }}
            whileInView={{ y: '0', opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            {homePage.services.gradient_title}
          </motion.h2>
        </div>
        <ul className='content-toggles nav' role='tablist'>
          {tabs?.map((tab, index) => (
            <TabItem
              title={tab.title}
              svg={tab.svg}
              id={tab.id}
              active={activeTab === index}
              onClick={() => setActiveTab(index)}
            />
          ))}
        </ul>
        <div className='tab-content mt-8'>
          <TabContent
            title={tabsContent[activeTab].title}
            gradientTitle={tabsContent[activeTab].gradientTitle}
            description={tabsContent[activeTab].description}
            descriptionPoints={tabsContent[activeTab].descriptionPoints}
            button={tabsContent[activeTab].button}
            activeTab={activeTab}
          />
        </div>
      </div>
    </section>
  );
}

interface TabItemProps {
  title: string;
  svg: string;
  id?: string;
  active?: boolean;
  onClick: () => void;
}

const TabItem = ({ title, svg, active, id, onClick }: TabItemProps) => {
  return (
    <motion.li
      id={id}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className={active ? 'active' : ''}
      role='tab'
      onClick={onClick}
    >
      <a className='' data-bs-toggle='tab' href={id ?? '#'}>
        {svg === 'website' ? (
          <WebsiteIcon />
        ) : svg === 'ecommerce' ? (
          <ECommerceIcon />
        ) : svg === 'seo' ? (
          <SeoIcon />
        ) : svg === 'hosting' ? (
          <HostingIcon />
        ) : svg === 'graphic-design' ? (
          <GraphicDesignIcon />
        ) : (
          ''
        )}
        <span>{title}</span>
      </a>
    </motion.li>
  );
};

interface TabContentProps {
  title: string;
  gradientTitle: string;
  description?: React.ReactNode;
  descriptionPoints?: React.ReactNode[];
  button: {
    text: string;
    link: string;
    svg: string;
  };
  activeTab: number;
}

const TabContent = ({
  title,
  gradientTitle,
  description,
  descriptionPoints,
  button,
  activeTab,
}: TabContentProps) => {
  const [renderLottie, setRenderLottie] = useState(false);

  return (
    <motion.div
      className='tab-pane fade active show'
      id='website-design-panel'
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className='row'>
        <div className='col-12 col-sm-6 col-lg-6'>
          <div className='headers mb-8'>
            <motion.h4
              initial={{ y: '100px', opacity: 0 }}
              whileInView={{ y: '0', opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              {title}
            </motion.h4>
            <motion.h2
              className='gradient'
              initial={{ y: '100px', opacity: 0 }}
              whileInView={{ y: '0', opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              {gradientTitle}
            </motion.h2>
          </div>
          <div className='image'>
            <Waypoint onEnter={() => setRenderLottie(true)} />
            {renderLottie && (
              <LottieAnimator
                animationData={
                  activeTab === 0
                    ? websiteDesignLottie
                    : activeTab === 1
                    ? ECommerceLottie
                    : activeTab === 2
                    ? SEOLottie
                    : activeTab === 3
                    ? HostingLottie
                    : activeTab === 4
                    ? GraphicDesignLottie
                    : null
                }
              />
            )}
          </div>
        </div>
        <div className='col-12 col-sm-6 col-lg-6'>
          <div className='content pb-3 mb-3'>
            <p>{description}</p>
          </div>
          <ul className='points'>
            {descriptionPoints?.map((descp) => (
              <li>{descp}</li>
            ))}
          </ul>
          <GradientButton
            text={button.text}
            link={button.link}
            svg={button.svg}
          />
        </div>
      </div>
    </motion.div>
  );
};
